module.exports = __webpack_public_path__ + "2f7e6a3e7d21ce38cc8deb535c11fd3e.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/thumbnail/public/images/studio2.jpg
// module id = 543
// module chunks = 0